// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_MarkPeriodCalculatedResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/mark_period_calculated endpoint
 *
 * Marks a payroll period as calculated (status 3)
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_MarkPeriodCalculatedResponseDados {
period_id: number
status: number
status_label: string
message: string
}

export type Payroll_MarkPeriodCalculatedResponse = ApiResponse<Payroll_MarkPeriodCalculatedResponseDados>;

registerResponseContract('Payroll_MarkPeriodCalculatedResponse', {
  period_id:    { type: 'number',  required: true },
  status:       { type: 'number',  required: true },
  status_label: { type: 'string',  required: true },
  message:      { type: 'string',  required: true },
})
